import * as React from "react";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { UitkCardAloha } from "uitk-react-cards";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import MediaDisplay from "../items/MediaDisplay";

export class StandaloneMediaEditorial extends EditorialBase {
  public constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  /**
   * An Editorial consists of HTML strings that we parse through with the best of
   * our abilities and display as is on the page. Mainly, we do not control the
   * content of an Editorial, we simply put them in the page.
   */
  public generate(props: ContentProps) {
    const { context } = props;
    const { title: moduleTitle, subtitle: moduleSubtitle } = this.editorial;
    const { id, title, media } = this.editorial.items[0];

    if (!media || media.length === 0) {
      return null;
    }

    return (
      <UitkSpacing padding={{ block: "three" }}>
        <div
          id={this.flexComponent.id}
          data-fm={this.flexComponent.fmId}
          data-fm-title-id={this.flexComponent.fmTitleId}
          className="StandaloneMediaEditorial"
        >
          <>
            {moduleTitle && (
              <UitkSpacing margin={{ blockend: "three" }}>
                <div>
                  <UitkHeading level={2} size={700}>
                    {moduleTitle}
                  </UitkHeading>
                  {moduleSubtitle && <UitkSubheading>{moduleSubtitle}</UitkSubheading>}
                </div>
              </UitkSpacing>
            )}
          </>
          <UitkCardAloha border={true}>
            <div>
              <MediaDisplay id={id} media={media} title={title} context={context} />
            </div>
          </UitkCardAloha>
        </div>
      </UitkSpacing>
    );
  }
}

export default StandaloneMediaEditorial;
